import { useState } from "react";
import Reveal from "./Reveal";
import { faqs } from "@/mocks/data";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="scroll-mt-24" aria-label="帮助答疑">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="mx-auto max-w-4xl text-center">
        <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
          <i className="ri-question-line" />
          帮助与说明
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-900 md:text-3xl">关于「吃瓜在线」，你可能想问</h2>
        <p className="mx-auto mt-2 max-w-2xl text-sm leading-relaxed text-foreground-500">
          我们从核实、求证、客观还原出发，回答大家最关心的问题，也欢迎把你的疑问反馈给我们。
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-3xl space-y-3">
        {faqs.map((item, i) => {
          const open = openIndex === i;
          return (
            <Reveal key={item.q} delay={i * 40}>
              <div
                className={`overflow-hidden rounded-xl border transition-colors ${
                  open ? "border-primary-200 bg-background-50" : "border-background-200/70 bg-background-100/50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                >
                  <h3 className={`text-sm font-semibold md:text-base ${open ? "text-primary-700" : "text-foreground-800"}`}>
                    {item.q}
                  </h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all ${
                      open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={`ri-add-line transition-transform duration-300 ${open ? "rotate-45" : ""}`} />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-4 pb-4 text-sm leading-relaxed text-foreground-600 md:px-5">{item.a}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}